import { Link } from 'react-router-dom';
import type { Problem } from '@attack100/shared';

interface ProblemCardProps {
  problem: Problem;
  onDelete?: (problem: Problem) => void;
}

function ProblemCard({ problem, onDelete }: ProblemCardProps) {
  const handleDelete = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (confirm(`Are you sure you want to delete "${problem.title}"? This will delete all angles and cannot be undone.`)) {
      onDelete?.(problem);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <Link to={`/problems/${problem.id}`} style={{ textDecoration: 'none' }}>
        <div className="card" style={{ cursor: 'pointer', transition: 'box-shadow 0.2s' }}>
          <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem', color: 'var(--gray-900)' }}>
            {problem.title}
          </h3>
          <p style={{ color: 'var(--gray-600)', fontSize: '0.875rem', marginBottom: '1rem' }}>
            {problem.description}
          </p>
          <div style={{ fontSize: '0.75rem', color: 'var(--gray-500)' }}>
            Created {new Date(problem.created_at).toLocaleDateString()}
          </div>
        </div>
      </Link>
      {onDelete && (
        <button
          onClick={handleDelete}
          className="btn-icon"
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            color: 'var(--gray-400)',
            fontSize: '1.25rem',
            background: 'white',
            borderRadius: '0.25rem',
            padding: '0.25rem 0.5rem'
          }}
          title="Delete problem"
        >
          ×
        </button>
      )}
    </div>
  );
}

export default ProblemCard;
